import { nextTick } from "@tarojs/taro"
import { isFunction } from "lodash"
import { DependencyList, EffectCallback, useEffect, useRef } from "react"

function useRenderedEffect(effect: EffectCallback, deps?: DependencyList) {
  const destructorRef = useRef<() => void>()

  useEffect(
    () => {
      nextTick(() => {
        const destructor = effect?.()
        if (isFunction(destructor)) {
          destructorRef.current = destructor
        }
      })

      return destructorRef.current
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps,
  )
}

export default useRenderedEffect
